export default {
  lineNumberColor: `#c5c8c6`,
  lineNumberBgColor: `#1d1f21`,
  backgroundColor: `#1d1f21`,
  textColor: `#c5c8c6`,
  substringColor: `#8abeb7`,
  keywordColor: `#81a2be`,
  attributeColor: `#b294bb`,
  selectorAttributeColor: `#81a2be`,
  docTagColor: `#b5bd68`,
  nameColor: `#f0c674`,
  builtInColor: `#de935f`,
  literalColor: `#cc6666`,
  bulletColor: `#81a2be`,
  codeColor: `#b294bb`,
  additionColor: `#b5bd68`,
  regexpColor: `#b5bd68`,
  symbolColor: `#cc6666`,
  variableColor: `#8abeb7`,
  templateVariableColor: `#8abeb7`,
  linkColor: `#cc6666`,
  selectorClassColor: `#de935f`,
  typeColor: `#de935f`,
  stringColor: `#b5bd68`,
  selectorIdColor: `#b294bb`,
  quoteColor: `#de935f`,
  templateTagColor: `#8abeb7`,
  deletionColor: `#cc6666`,
  titleColor: `#f0c674`,
  sectionColor: `#de935f`,
  commentColor: `#707880`,
  metaKeywordColor: `#c5c8c6`,
  metaColor: `#707880`,
  functionColor: `#c5c8c6`,
  numberColor: `#cc6666`,
}
